import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"];
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { pricePostingStatusList } from "@/js/lists.ts";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { filterDecimal2digitsKey } from "@/js/events/keycodes.js";
import WineNaming from "@/components/products/WineNaming.vue";
import PricePostedUsaModificationPopover from "@/components/price-posting/usa-pro/PricePostedUsaModificationPopover.vue";
import PricePostedUsaEditModalColumn from "@/components/price-posting/usa-pro/PricePostedUsaEditModalColumn.vue";
import PricePostedUsaDraftEditionWarningPopover from "@/components/price-posting/usa-pro/PricePostedUsaDraftEditionWarningPopover.vue";
import confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultAddForm = {
  pricePostingUsaProWineId: null,
  threshold: null,
  priceUsdDefaultShippingIncludedPerBottle: null,
  valid: false
};
export default {
  name: "WineDiscountPricePostedEditModal",
  props: {
    wine: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    WineNaming: WineNaming,
    PricePostedUsaModificationPopover: PricePostedUsaModificationPopover,
    PricePostedUsaEditModalColumn: PricePostedUsaEditModalColumn,
    PricePostedUsaDraftEditionWarningPopover: PricePostedUsaDraftEditionWarningPopover,
    confirm: confirm,
    ErrorModal: ErrorModal
  },
  data: function data() {
    return {
      options: {
        color: "primary",
        zIndex: 2000
      },
      shown: false,
      gettingPricePostings: {
        results: [],
        cancellationToken: null,
        isPending: false
      },
      gettingItems: {
        results: [],
        rawResults: [],
        cancellationToken: null,
        isPending: false
      },
      creatingUsableData: {
        isPending: false,
        results: []
      },
      creatingPriceUsdDefaultShippingIncluded: {
        cancellationToken: null,
        isPending: false,
        isConfiguring: false,
        form: {
          valid: false,
          value: null,
          pricePostingUsaProId: null,
          wineId: null
        }
      },
      editingPriceUsdDefaultShippingIncluded: {
        cancellationToken: null,
        isPending: false,
        isConfiguring: false,
        form: {
          valid: false,
          value: null,
          pricePostingUsaProWineId: null
        }
      },
      editingDiscountPrice: {
        cancellationToken: null,
        isPending: false,
        isConfiguring: false,
        form: {
          valid: false,
          value: null,
          ppostUsaproWineConditionalId: null
        }
      },
      deletingDiscountPrice: {
        cancellationToken: null,
        isPending: false
      },
      addingDiscountPrice: {
        cancellationToken: null,
        isPending: false,
        isConfiguring: false,
        form: _objectSpread({}, defaultAddForm)
      },
      headers: [{
        text: "Status",
        value: "status",
        align: "center"
      }, {
        text: "Application Month",
        value: "applicationMonth",
        align: "center"
      }, {
        text: "Price Incl. Shipp. (US$)",
        value: "priceUsdDefaultShippingIncluded",
        align: "start"
      }, {
        text: "Discount 6 btls incl. ship (US$)",
        value: "priceDiscount6",
        align: "start"
      }, {
        text: "Discount 12 btls incl. ship (US$)",
        value: "priceDiscount12",
        align: "start"
      }, {
        text: "Discount 36 btls incl. ship (US$)",
        value: "priceDiscount36",
        align: "start"
      }, {
        text: "Discount 60 btls incl. ship (US$)",
        value: "priceDiscount60",
        align: "start"
      }, {
        text: "Discount 120 btls incl. ship (US$)",
        value: "priceDiscount120",
        align: "start"
      }, {
        text: "Discount 300 btls incl. ship (US$)",
        value: "priceDiscount300",
        align: "start"
      }],
      formRules: formRules,
      filterDecimal2digitsKey: filterDecimal2digitsKey,
      ERROR_DATA: ERROR_DATA,
      pricePostingStatusList: pricePostingStatusList
    };
  },
  computed: {
    isAnyFormConfiguring: function isAnyFormConfiguring() {
      return this.creatingPriceUsdDefaultShippingIncluded.isConfiguring || this.editingPriceUsdDefaultShippingIncluded.isConfiguring || this.editingDiscountPrice.isConfiguring || this.addingDiscountPrice.isConfiguring;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.creatingPriceUsdDefaultShippingIncluded.isPending || this.editingPriceUsdDefaultShippingIncluded.isPending || this.editingDiscountPrice.isPending || this.addingDiscountPrice.isPending || this.deletingDiscountPrice.isPending;
    }
  },
  methods: {
    open: function open() {
      this.shown = true;
      this.fetchDataAndItems();
    },
    close: function close() {
      this.shown = false;
      this.editingPriceUsdDefaultShippingIncluded.isConfiguring = false;
      this.editingDiscountPrice.isConfiguring = false;
      this.$emit("close");
    },
    fetchDataAndItems: function fetchDataAndItems() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.creatingUsableData.isPending = true;
              _this2.creatingUsableData.results = [];
              _context.next = 4;
              return _this2.fetchPricePostings();
            case 4:
              _context.next = 6;
              return _this2.fetchItems();
            case 6:
              _this2.createUsableData();
              _this2.creatingUsableData.isPending = false;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchPricePostings: function fetchPricePostings() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$gettingPricePo;
        var data, paramsQuery, _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.gettingPricePostings.results = [];
              _this3.gettingPricePostings.isPending = true;
              (_this3$gettingPricePo = _this3.gettingPricePostings.cancellationToken) === null || _this3$gettingPricePo === void 0 || _this3$gettingPricePo.cancel();
              _this3.gettingPricePostings.cancellationToken = axios.CancelToken.source();
              data = {
                statusAllowed: [pricePostingStatusList.DRAFT.id, pricePostingStatusList.POSTED.id]
              };
              paramsQuery = Object.encodeToUri(data);
              _this = _this3;
              _context2.next = 9;
              return request("/v1/price-posting/filtered?params=".concat(paramsQuery), "get", {}, true, "api", null, _this.gettingPricePostings.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this3.gettingPricePostings.isPending = false;
                  var errorData = getErrorData(e, "Unable to get list of price postings", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 9:
              response = _context2.sent;
              _this3.gettingPricePostings.results = _toConsumableArray(response.data.value);
              _this3.gettingItems.isPending = false;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchItems: function fetchItems() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$gettingItems$c;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.gettingItems.results = [];
              _this4.gettingItems.isPending = true;
              (_this4$gettingItems$c = _this4.gettingItems.cancellationToken) === null || _this4$gettingItems$c === void 0 || _this4$gettingItems$c.cancel();
              _this4.gettingItems.cancellationToken = axios.CancelToken.source();
              _this = _this4;
              _context3.next = 7;
              return request("/v1/price-posting/conditionals-discounts/wine/".concat(_this4.wine.id_wine), "get", {}, true, "api", null, _this.gettingItems.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this4.gettingItems.isPending = false;
                  var errorData = getErrorData(e, "Unable to get list of available users", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              response = _context3.sent;
              _this4.gettingItems.rawResults = _toConsumableArray(response.data);
              _this4.gettingItems.results = _this4.mapPricesToColumns(response.data);
              _this4.gettingItems.isPending = false;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    createUsableData: function createUsableData() {
      var _this5 = this;
      this.gettingPricePostings.results.forEach(function (pp) {
        var lineUsableData = _objectSpread({}, pp);
        var item = _this5.gettingItems.results.find(function (item) {
          return item.ppostUsaproId == pp.id;
        });
        if (item) {
          lineUsableData.dataItem = _objectSpread({}, item);
        } else {
          lineUsableData.dataItem = null;
        }
        _this5.creatingUsableData.results.push(lineUsableData);
      });
    },
    startBasePriceCreateMode: function startBasePriceCreateMode(item) {
      this.creatingPriceUsdDefaultShippingIncluded.isConfiguring = true;
      this.creatingPriceUsdDefaultShippingIncluded.form = {
        pricePostingUsaProId: item.id,
        value: null
      };
    },
    resetBasePriceCreateMode: function resetBasePriceCreateMode(item) {
      this.creatingPriceUsdDefaultShippingIncluded.isConfiguring = false;
      this.creatingPriceUsdDefaultShippingIncluded.form = {
        pricePostingUsaProId: null,
        value: null
      };
    },
    createPriceUsdDefaultShippingIncluded: function createPriceUsdDefaultShippingIncluded(item) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this6$creatingPriceU;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.creatingPriceUsdDefaultShippingIncluded.isPending = true;
              (_this6$creatingPriceU = _this6.creatingPriceUsdDefaultShippingIncluded.cancellationToken) === null || _this6$creatingPriceU === void 0 || _this6$creatingPriceU.cancel();
              _this6.creatingPriceUsdDefaultShippingIncluded.cancellationToken = axios.CancelToken.source();
              data = {
                pricePostingUsaProId: _this6.creatingPriceUsdDefaultShippingIncluded.form.pricePostingUsaProId,
                wineId: _this6.wine.id_wine,
                priceUsdDefaultShippingIncludedPerBottle: _this6.creatingPriceUsdDefaultShippingIncluded.form.value
              };
              _this = _this6;
              _context4.next = 7;
              return request("/v1/price-posting/price", "post", data, true, "api", null, _this.creatingPriceUsdDefaultShippingIncluded.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this6.creatingPriceUsdDefaultShippingIncluded.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to create price", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              _this6.$toasted.show("Price saved.", {
                type: "success"
              });
              _this6.creatingPriceUsdDefaultShippingIncluded.isPending = false;
              _this6.resetBasePriceCreateMode(item);
              _this6.fetchDataAndItems();
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    startBasePriceEditMode: function startBasePriceEditMode(item) {
      this.editingPriceUsdDefaultShippingIncluded.isConfiguring = true;
      this.editingPriceUsdDefaultShippingIncluded.form = {
        pricePostingUsaProWineId: item.ppostUsaproWineId,
        value: item.priceUsdDefaultShippingIncluded.value
      };
      item.priceUsdDefaultShippingIncluded.isEditing = true;
    },
    resetBasePriceEditMode: function resetBasePriceEditMode(item) {
      this.editingPriceUsdDefaultShippingIncluded.isConfiguring = false;
      this.editingPriceUsdDefaultShippingIncluded.form = {
        pricePostingUsaProWineId: null,
        value: null
      };
      item.priceUsdDefaultShippingIncluded.isEditing = false;
    },
    savePriceUsdDefaultShippingIncluded: function savePriceUsdDefaultShippingIncluded(item) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this7$editingPriceUs;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this7.editingPriceUsdDefaultShippingIncluded.isPending = true;
              (_this7$editingPriceUs = _this7.editingPriceUsdDefaultShippingIncluded.cancellationToken) === null || _this7$editingPriceUs === void 0 || _this7$editingPriceUs.cancel();
              _this7.editingPriceUsdDefaultShippingIncluded.cancellationToken = axios.CancelToken.source();
              data = {
                pricePostingUsaProWineId: _this7.editingPriceUsdDefaultShippingIncluded.form.pricePostingUsaProWineId,
                priceUsdDefaultShippingIncludedPerBottle: _this7.editingPriceUsdDefaultShippingIncluded.form.value
              };
              _this = _this7;
              _context5.next = 7;
              return request("/v1/price-posting/price", "put", data, true, "api", null, _this.editingPriceUsdDefaultShippingIncluded.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this7.editingPriceUsdDefaultShippingIncluded.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to edit price", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              _this7.$toasted.show("Price saved.", {
                type: "success"
              });
              _this7.editingPriceUsdDefaultShippingIncluded.isPending = false;
              _this7.resetBasePriceEditMode(item);
              _this7.fetchDataAndItems();
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    startDiscountPriceEditMode: function startDiscountPriceEditMode(item, threshold) {
      var key = "priceDiscount".concat(threshold);
      var discount = item[key];
      if (discount) {
        this.editingDiscountPrice.isConfiguring = true;
        this.editingDiscountPrice.form = {
          ppostUsaproWineConditionalId: discount.ppostUsaproWineConditionalId,
          value: discount.value,
          threshold: threshold
        };
        discount.isEditing = true;
      }
    },
    resetDiscountPriceEditMode: function resetDiscountPriceEditMode(item, threshold) {
      var key = "priceDiscount".concat(threshold);
      var discount = item[key];
      if (discount) {
        this.editingDiscountPrice.isConfiguring = false;
        this.editingDiscountPrice.form = {
          ppostUsaproWineConditionalId: null,
          value: null,
          threshold: null
        };
        discount.isEditing = false;
      }
    },
    saveWineDiscountPrice: function saveWineDiscountPrice(item, threshold) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this8$editingDiscoun;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this8.editingDiscountPrice.isPending = true;
              (_this8$editingDiscoun = _this8.editingDiscountPrice.cancellationToken) === null || _this8$editingDiscoun === void 0 || _this8$editingDiscoun.cancel();
              _this8.editingDiscountPrice.cancellationToken = axios.CancelToken.source();
              data = {
                pricePostingUsaproWineConditionalId: _this8.editingDiscountPrice.form.ppostUsaproWineConditionalId,
                priceUsdDefaultShippingIncludedPerBottle: _this8.editingDiscountPrice.form.value
              };
              _this = _this8;
              _context6.next = 7;
              return request("/v1/price-posting/conditionals-discounts", "put", data, true, "api", null, _this.editingDiscountPrice.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this8.editingDiscountPrice.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to edit discount price", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              _this8.$toasted.show("Discount price saved.", {
                type: "success"
              });
              _this8.editingDiscountPrice.isPending = false;
              _this8.resetDiscountPriceEditMode(item, threshold);
              _this8.fetchDataAndItems();
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    startDiscountPriceAddMode: function startDiscountPriceAddMode(item, threshold) {
      this.addingDiscountPrice.isConfiguring = true;
      this.addingDiscountPrice.form = {
        pricePostingUsaProWineId: item.ppostUsaproWineId,
        threshold: threshold,
        priceUsdDefaultShippingIncludedPerBottle: null
      };
    },
    resetDiscountPriceAddMode: function resetDiscountPriceAddMode() {
      this.addingDiscountPrice.isConfiguring = false;
      this.addingDiscountPrice.form = _objectSpread({}, defaultAddForm);
    },
    addWineDiscountPrice: function addWineDiscountPrice() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this9$addingDiscount;
        var _this9$addingDiscount2, valid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this9.addingDiscountPrice.isPending = true;
              (_this9$addingDiscount = _this9.addingDiscountPrice.cancellationToken) === null || _this9$addingDiscount === void 0 || _this9$addingDiscount.cancel();
              _this9.addingDiscountPrice.cancellationToken = axios.CancelToken.source();
              _this9$addingDiscount2 = _this9.addingDiscountPrice.form, valid = _this9$addingDiscount2.valid, withoutValid = _objectWithoutProperties(_this9$addingDiscount2, _excluded);
              _this = _this9;
              _context7.next = 7;
              return request("/v1/price-posting/conditionals-discounts", "post", withoutValid, true, "api", null, _this.addingDiscountPrice.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this9.addingDiscountPrice.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to add discount price", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              _this9.$toasted.show("Discount price saved.", {
                type: "success"
              });
              _this9.addingDiscountPrice.isPending = false;
              _this9.resetDiscountPriceAddMode();
              _this9.fetchDataAndItems();
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    confirmDeleteDiscountPrice: function confirmDeleteDiscountPrice(item, threshold) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this10.$refs.confirm.open("Delete", "Are you sure you want to delete this discount ?", {
                color: "red"
              });
            case 2:
              ok = _context8.sent;
              if (ok) _this10.deleteDiscountPrice(item, threshold);
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    deleteDiscountPrice: function deleteDiscountPrice(item, threshold) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this11$deletingDisco;
        var key, discount, _this;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this11.deletingDiscountPrice.isPending = true;
              (_this11$deletingDisco = _this11.deletingDiscountPrice.cancellationToken) === null || _this11$deletingDisco === void 0 || _this11$deletingDisco.cancel();
              _this11.deletingDiscountPrice.cancellationToken = axios.CancelToken.source();
              key = "priceDiscount".concat(threshold);
              discount = item[key];
              _this = _this11;
              _context9.next = 8;
              return request("/v1/price-posting/conditionals-discounts/".concat(discount.ppostUsaproWineConditionalId), "delete", null, true, "api", null, _this.deletingDiscountPrice.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update association", true);
                handleErrorData(_this, errorData);
                _this.deletingDiscountPrice.isPending = false;
                throw e;
              });
            case 8:
              _this11.deletingDiscountPrice.isPending = false;
              _this11.fetchDataAndItems();
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    mapPricesToColumns: function mapPricesToColumns(dataArray) {
      var keyMap = {
        6: "priceDiscount6",
        12: "priceDiscount12",
        36: "priceDiscount36",
        60: "priceDiscount60",
        120: "priceDiscount120",
        300: "priceDiscount300"
      };
      var grouped = {};
      dataArray.forEach(function (item) {
        var wineKey = item.ppostUsaproWineId;
        if (!grouped[wineKey]) {
          var _item$lastBasePriceMo, _item$lastBasePriceMo2, _item$lastBasePriceMo3, _item$lastBasePriceMo4;
          grouped[wineKey] = {
            ppostUsaproWineId: item.ppostUsaproWineId,
            ppostUsaproId: item.ppostUsaproId,
            applicationDate: item.applicationDate,
            priceUsdDefaultShippingIncluded: {
              value: item.priceUsdDefaultShippingIncluded,
              previousPriceUsdDefaultShippingIncludedPerBottle: item.lastBasePriceModification.previousPriceUsdDefaultShippingIncludedPerBottle,
              originalPriceUsdDefaultShippingIncludedPerBottle: item.lastBasePriceModification.originalPriceUsdDefaultShippingIncludedPerBottle,
              previousWsalerPriceUsdDefaultShippingIncludedPerBottle: item.previousWsalerPriceUsdDefaultShippingIncludedPerBottle,
              originalWsalerPriceUsdDefaultShippingIncludedPerBottle: item.originalWsalerPriceUsdDefaultShippingIncludedPerBottle,
              lastModifiedAt: (_item$lastBasePriceMo = item.lastBasePriceModification) === null || _item$lastBasePriceMo === void 0 ? void 0 : _item$lastBasePriceMo.lastModifiedAt,
              isPriceEditedManually: (_item$lastBasePriceMo2 = item.lastBasePriceModification) === null || _item$lastBasePriceMo2 === void 0 ? void 0 : _item$lastBasePriceMo2.isPriceEditedManually,
              isPriceAddedManually: (_item$lastBasePriceMo3 = item.lastBasePriceModification) === null || _item$lastBasePriceMo3 === void 0 ? void 0 : _item$lastBasePriceMo3.isPriceAddedManually,
              lastModifiedByUser: ((_item$lastBasePriceMo4 = item.lastBasePriceModification) === null || _item$lastBasePriceMo4 === void 0 ? void 0 : _item$lastBasePriceMo4.lastModifiedByUser) || null,
              isEditing: false
            },
            status: item.status
          };
        }
        var discountKey = keyMap[item.bottleThreshold];
        if (discountKey) {
          var _item$lastDiscountMod, _item$lastDiscountMod2, _item$lastDiscountMod3, _item$lastDiscountMod4, _item$lastDiscountMod5;
          grouped[wineKey][discountKey] = {
            ppostUsaproWineConditionalId: item.ppostUsaproWineConditionalId,
            previousPriceUsdDefaultShippingIncludedPerBottle: item.lastDiscountModification.previousPriceUsdDefaultShippingIncludedPerBottle,
            originalPriceUsdDefaultShippingIncludedPerBottle: item.lastDiscountModification.originalPriceUsdDefaultShippingIncludedPerBottle,
            value: item.priceDiscountUsdDefaultShippingIncluded,
            lastModifiedAt: (_item$lastDiscountMod = item.lastDiscountModification) === null || _item$lastDiscountMod === void 0 ? void 0 : _item$lastDiscountMod.lastModifiedAt,
            isPriceEditedManually: (_item$lastDiscountMod2 = item.lastDiscountModification) === null || _item$lastDiscountMod2 === void 0 ? void 0 : _item$lastDiscountMod2.isPriceEditedManually,
            isPriceAddedManually: (_item$lastDiscountMod3 = item.lastDiscountModification) === null || _item$lastDiscountMod3 === void 0 ? void 0 : _item$lastDiscountMod3.isPriceAddedManually,
            hasBeenDeleted: (_item$lastDiscountMod4 = item.lastDiscountModification) === null || _item$lastDiscountMod4 === void 0 ? void 0 : _item$lastDiscountMod4.hasBeenDeleted,
            lastModifiedByUser: ((_item$lastDiscountMod5 = item.lastDiscountModification) === null || _item$lastDiscountMod5 === void 0 ? void 0 : _item$lastDiscountMod5.lastModifiedByUser) || null,
            isEditing: false
          };
        }
      });
      return Object.values(grouped).sort(function (a, b) {
        return new Date(b.applicationDate) - new Date(a.applicationDate);
      });
    },
    getFormattedMonthYear: function getFormattedMonthYear(date) {
      if (!(date instanceof Date)) {
        date = new Date(date);
      }
      return date.formatStringMonth();
    }
  }
};